// Laboratory documentation: https://product.hubteam.com/docs/laboratory/guides/coding-a-frontend-experiment.html
'use es6';

import portalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
import experiments from '../../experiments.yaml';
export const laboratoryClient = createClient({
  identifiers: {
    portalId: portalIdParser.get()
  },
  experiments
});